// see https://gist.github.com/ziggi/2f15832b57398649ee9b
export default function getParents(el, selector) {
  if (el) {
    var elements = [];
    var elem = el;
    var ishaveselector = selector !== undefined;
    while ((elem = elem.parentElement) !== null) {
      if (elem.nodeType !== Node.ELEMENT_NODE) {
        continue;
      }
      if (!ishaveselector || elem.matches(selector)) {
        elements.push(elem);
      }
    }
    return elements;
  } else {
    return [];
  }
}
